<template>
	<v-footer app absolute height="auto">
		<v-container ref="footerSlider">
			<v-row no-gutters class="d-none d-lg-flex mb-4">
				<v-layout d-flex align-center justify-center>
					<v-icon
						small
						@click="toggle">
						mdi-chevron-left
					</v-icon>
					<span class="subtitle-2 font-weight-light text-uppercase">{{slideTitle}}</span>
					<v-icon
						small
						@click="toggle">
						mdi-chevron-right
					</v-icon>
				</v-layout>
			</v-row>

			<v-row no-gutters class="footer-slide" :class="[activeSlide === 'ohp' ? 'd-flex' : 'd-none']">
				<v-col>
					<v-row>
						<p class="overline">PROMOTOR:</p>
					</v-row>
					<v-row align="center">
						<a href="https://adiber.pt/" target="_blank"><v-img src="@/assets/img/logo_adiber.png" alt="ADIBER - Associação de Desenvolvimento Integrado da Beira Serra" contain width="3rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col>
					<v-row>
						<p class="overline">APOIO TÉCNICO:</p>
					</v-row>
					<v-row align="center">
						<a href="https://www.gowe.pt/" target="_blank"><v-img src="@/assets/img/logo_gowe.png" alt="go'we" contain width="4rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col>
					<v-row>
						<p class="overline">PARCEIRO:</p>
					</v-row>
					<v-row align="center">
						<a href="http://www.aeoh.pt/" target="_blank"><v-img src="@/assets/img/logo_aeoh.png" alt="Agrupamento de Escolas de Oliveira do Hospital" contain width="4rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col>
					<v-row>
						<p class="overline">INVESTIDOR SOCIAL:</p>
					</v-row>
					<v-row align="center">
						<a href="https://www.cm-oliveiradohospital.pt/" target="_blank"><v-img src="@/assets/img/logo_oliveira_hospital.png" alt="Câmara Municipal de Oliveira do Hospital" contain width="3rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col cols="4">
					<v-row>
						<p class="overline">COFINANCIADO POR:</p>
					</v-row>
					<v-row align="center" justify="space-between">
						<a href="https://inovacaosocial.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_pis.png" alt="Portugal Inovação Social" contain width="4rem" /></a>
						<a href="https://www.poch.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_poch.png" alt="Programa Operacional Capital Humano" contain width="4rem" /></a>
						<a href="https://www.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_portugal2020.png" alt="Portugal 2020" contain width="4rem" /></a>
						<a href="http://ec.europa.eu/esf/home.jsp?langId=pt" target="_blank"><v-img src="@/assets/img/logo_ue_fse.png" alt="Fundo Social Europeu" contain width="4rem" /></a>
					</v-row>
				</v-col>
			</v-row>

			<v-row no-gutters class="footer-slide" :class="[activeSlide === 'ian' ? 'd-flex' : 'd-none']">
				<v-col cols="3">
					<v-row>
						<p class="overline">PROMOTORES:</p>
					</v-row>
					<v-row align="center" justify="space-between">
						<a href="https://www.facebook.com/aldeiadosgirassois/" target="_blank"><v-img src="@/assets/img/logo_aldeia_girassois.png" alt="Aldeia dos Girassóis" contain width="4rem" /></a>
						<a href="https://www.gowe.pt/" target="_blank"><v-img src="@/assets/img/logo_gowe.png" alt="go'we" contain width="4rem" /></a>
						<a href="https://www.colegiosjose.pt/" target="_blank"><v-img src="@/assets/img/logo_colegio_sao_jose.png" alt="Colégio de São José" contain width="4rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col>
					<v-row>
						<p class="overline">PARCEIRO:</p>
					</v-row>
					<v-row align="center">
						<a href="https://www.agrupamentoidanha.com/" target="_blank"><v-img src="@/assets/img/logo_aejsr.png" alt="Agrupamento de Escolas José Silvestre Ribeiro" contain width="4rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col>
					<v-row>
						<p class="overline">INVESTIDOR SOCIAL:</p>
					</v-row>
					<v-row align="center">
						<a href="http://www.cm-idanhanova.pt/" target="_blank"><v-img src="@/assets/img/logo_idanhaanova.png" alt="Câmara Municipal de Idanha-a-Nova" contain width="4rem" /></a>
					</v-row>
				</v-col>
				<v-spacer />
				<v-col cols="4">
					<v-row>
						<p class="overline">COFINANCIADO POR:</p>
					</v-row>
					<v-row align="center" justify="space-between">
						<a href="https://inovacaosocial.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_pis.png" alt="Portugal Inovação Social" contain width="4rem" /></a>
						<a href="http://www.poise.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_poise.png" alt="Programa Operacional Inclusão Social e Emprego" contain width="4rem" /></a>
						<a href="https://www.portugal2020.pt/" target="_blank"><v-img src="@/assets/img/logo_portugal2020.png" alt="Portugal 2020" contain width="4rem" /></a>
						<a href="http://ec.europa.eu/esf/home.jsp?langId=pt" target="_blank"><v-img src="@/assets/img/logo_ue_fse.png" alt="Fundo Social Europeu" contain width="4rem" /></a>
					</v-row>
				</v-col>
			</v-row>

			<v-row justify="space-between">
				<v-col cols="12" sm="8">
					<span class="caption">&copy; 2023 — Ensinar é Voar</span>
				</v-col>
				<v-col cols="12" sm="4" align="end">
					<span class="overline grey--text text--darken-3">Desenvolvido por <a href="http://www.brivcase.com/" target="_blank">BRIVCASE IT Solutions</a>.</span>
				</v-col>
			</v-row>
		</v-container>
    </v-footer>
</template>



<script>
	export default {
		data () {
			return {
				slides: {
					ohp: "Oliveira do Hospital",
					ian: "Idanha-a-Nova"
				},
				activeSlide: "ohp"
			}
		},
		computed: {
			slideTitle () {
				return this.slides[this.activeSlide];
			}
		},
        methods: {
			toggle () {
				if (this.activeSlide === "ohp") {
					this.activeSlide = "ian";
				}
				else if (this.activeSlide === "ian") {
					this.activeSlide = "ohp";
				}
			},
        },
		mounted() {
			this.loopinterval = setInterval(function () {
				this.toggle();
			}.bind(this), 8000);
		} 
	}
</script>